<template>
  <div id="jump" :class="{ isNoticeHead: !$store.state.isIndexTopNotice, mainBody: $store.state.isIndexTopMainBody }" class="pt-4 pb-8 lg:py-6 xl:py-8 px-2 lg:px-8 mx-auto text-NotoSansRegular min-h-60">
    <main class="w-full flex justify-center md:pt-3 flex-col items-center">
      <div class="flex py-10 px-8 md:px-10 border borderRed bg-white rounded justify-center w-full md:w-auto">
        <section class="text-center tracking-wider">
          <h6 class="textColorRed text-xl md:text-2xl">恭喜你！會員註冊成功囉</h6>
          <h6 class="textColorRed text-xl md:text-2xl">請選擇跳轉頁面 </h6>

          <div class="sm:flex justify-center mt-8">
            <router-link :to="{ name: 'index' }" class="btn-back block rounded-2 text-white py-2 px-8 m-2 whitespace-no-wrap">回LiveABC官網</router-link>
            <a href="https://livestudy.liveabc.com/" class="btn-back block rounded-2 text-white py-2 px-8 m-2 whitespace-no-wrap" target="_blank">
              回LiveStudy行動學習網
            </a>
            <a href="https://ai.liveabc.com/login" class="btn-back block rounded-2 text-white py-2 px-8 m-2 whitespace-no-wrap" target="_blank">
              回AI英語學習教室
            </a>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'register_success',
  metaInfo () {
    return {
      title: '註冊成功',
      titleTemplate: null
    }
  }
}
</script>

<style lang="scss" scoped>
  .min-h-60 {
    min-height: 60vh;
  }
  .btn-back {
    background: #EB5757;
    transition: .3s;
    &:hover {
      background: #e60012;
    }
  }
</style>
